var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('redeem-modal', {
    ref: "redeemModal",
    attrs: {
      "coupon": _vm.selectedRedeemCode
    },
    on: {
      "confirmed": _vm.refresh
    }
  }), _vm.fetching ? _c('Loading') : _vm._e(), _vm.deepGet(_vm.benefitCard, 'config.page_image') ? _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.deepGet(_vm.benefitCard, 'config.page_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "benefit-tabs",
    class: {
      'pt-3': false === _vm.tabsContainImages,
      'px-3': false === _vm.tabsContainImages
    }
  }, _vm._l(_vm.dataSources, function (tab) {
    return _c('a', {
      key: tab.path,
      staticClass: "benefit-tab",
      class: {
        'active-tab': _vm.$route.params.tabPath === tab.path
      },
      on: {
        "click": function click($event) {
          return _vm.handleTabChanges(tab);
        }
      }
    }, [tab.tab_image ? _c('img', {
      attrs: {
        "src": tab.tab_image
      }
    }) : [_vm._v(_vm._s(tab.tab_name))]], 2);
  }), 0), _c('div', {
    staticClass: "px-3 overflow-x-hidden page"
  }, [_vm.tabPath ? [_vm.deepGet(_vm.dataSource, 'form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.dataSource, 'form_title')))]) : _vm._e(), _vm.deepGet(_vm.dataSource, 'form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.dataSource, 'form_desc')))]) : _vm._e(), _c('div', {
    staticClass: "benefit-card border border-1 p-2"
  }, _vm._l(_vm.selectedRedeemCodes, function (redeemCode, index) {
    return _c('div', {
      key: redeemCode.id,
      staticClass: "p-2",
      style: {
        minWidth: "".concat(100 / Math.round(_vm.selectedRedeemCodes.length / (_vm.selectedRedeemCodes.length > 4 ? 2 : 1)), "%")
      }
    }, [_c('div', {
      staticClass: "benefit-card__point",
      class: {
        'benefit-card__point--with-stamp': ['applied', 'expiring_soon'].includes(redeemCode.status)
      }
    }, [redeemCode.status == 'applied' ? _c('span', [_vm._v(_vm._s(index + 1))]) : redeemCode.status == 'applied_and_not_yet' ? _c('span', [_vm._v("未開始")]) : redeemCode.status == 'expiring_soon' ? _c('span', [_vm._v("即將"), _c('br'), _vm._v("到期")]) : redeemCode.status == 'redeemed' ? _c('span', [_vm._v("已使用")]) : redeemCode.status == 'expired' ? _c('span', [_vm._v("已過期")]) : _vm._e()])]);
  }), 0), _c('div', {
    staticClass: "page__content"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.dataSource, "content")))]), _c('div', {
    staticClass: "page__button s-space-y-4 px-0"
  }, [_vm.deepGet(_vm.dataSource, 'use_now_button_text') ? _c('ShareButton', {
    attrs: {
      "variant": "s-btn-outline-primary",
      "disabled": _vm.redeemableCodes.length === 0
    },
    on: {
      "click": _vm.handleUseNowButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.dataSource, 'use_now_button_text')) + " ")]) : _vm._e(), _vm.deepGet(_vm.dataSource, 'button_text') ? _c('MemberButton', {
    attrs: {
      "button-text": _vm.deepGet(_vm.dataSource, 'button_text'),
      "button-url": _vm.deepGet(_vm.dataSource, 'button_url'),
      "type": _vm.deepGet(_vm.dataSource, 'button_action')
    }
  }) : _vm._e(), _vm.deepGet(_vm.dataSource, 'tab_button_text') ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.deepGet(_vm.dataSource, 'tab_button_text'),
      "button-url": _vm.deepGet(_vm.dataSource, 'tab_button_url'),
      "type": _vm.deepGet(_vm.dataSource, 'tab_button_action')
    }
  }) : _vm._e()], 1)] : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }